export default __webpack_public_path__ + "static/media/crisis_asmatica_severa_uti.e9d893d0.pdf";